import { msalInstance } from './index';
import { tokenRequest } from './authConfig';


export async function GetAuthTokenAsync(): Promise<string> {
  const account = msalInstance.getAllAccounts()[0];

  const response = await msalInstance.acquireTokenSilent({
    ...tokenRequest,
    account: account
  });

  return response.accessToken;
}